module.exports = __webpack_public_path__ + "static/media/new-logo-3.667487c0.png";